module.exports = __webpack_public_path__ + "media/images/icons/facebook_commerce-c3cc0d2776688941e5aa02bd39cd68e7.svg";